import React, { useEffect, useState } from "react"
import { Card, CardBody, CardFooter, Col, Row } from "reactstrap"
import { SaveButton } from "components/Buttons"
import { connect } from "react-redux"
import { getAppOpensMonthReport } from "store/actions"
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"

const EngagementTrendsCard = ({
  handleViewMore,
  appOpensMonthReport,
  getAppOpensMonthReport,
  eventId,
}) => {
  const [chartData, setChartData] = useState([])

  useEffect(() => {
    const day = new Date().getDate()
    getAppOpensMonthReport({
      id: eventId,
      days: day,
    })
  }, [])

  useEffect(() => {
    if (appOpensMonthReport) {
      let data = [...appOpensMonthReport]
      setChartData(
        data.sort((d1, d2) => {
          const date1 = new Date(d1?.date).getTime()
          const date2 = new Date(d2?.date).getTime()
          if (date1 < date2) {
            return -1
          }
          if (date1 > date2) {
            return 1
          }
          return 0
        })
      )
    }
  }, [appOpensMonthReport])

  return (
    <Card className="mini-stats-wid flex-grow-1">
      <CardBody>
        <Row>
          <Col>
            <span className="h5">Experience Engagement Trends </span>
            <span className="text-muted fw-medium">(month-to-date)</span>
          </Col>
        </Row>
        {chartData?.length > 0 ? (
          <Row style={{ height: "200px" }}>
            <Col>
              <ResponsiveContainer>
                <AreaChart
                  data={chartData || []}
                  width={500}
                  height={200}
                  margin={{
                    top: 20,
                    right: 15,
                    left: 0,
                    bottom: 5,
                  }}
                >
                  <defs>
                    <linearGradient id="colorUvv" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#556ee6" stopOpacity={0.7} />
                      <stop
                        offset="80%"
                        stopColor="#556ee6"
                        stopOpacity={0.3}
                      />
                    </linearGradient>
                  </defs>
                  <XAxis dataKey="date" />
                  <YAxis allowDecimals={false} />
                  <Tooltip cursor={{ fill: "rgb(220, 220, 220, 0.5)" }} />
                  <Area
                    dataKey="total_views"
                    type="monotone"
                    name="Total views"
                    stroke="#5e5c96"
                    strokeWidth={1.5}
                    fill="url(#colorUvv)"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </Col>
          </Row>
        ) : (
          <Row className="my-3">
            <Col>
              <p>No data to display</p>
            </Col>
          </Row>
        )}
      </CardBody>
      <CardFooter style={{ background: "white" }} className="pt-0">
        <Row className="d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              color={"primary"}
              size="sm"
              content="View More"
              onClick={handleViewMore}
            />
          </Col>
        </Row>
      </CardFooter>
    </Card>
  )
}

const mapStateToProps = state => ({
  appOpensMonthReport: state.Analytics.appOpensMonthReport,
})

const mapDispatchToProps = dispatch => ({
  getAppOpensMonthReport: values => dispatch(getAppOpensMonthReport(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EngagementTrendsCard)
